.SkeletonContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-lg);

  .ButtonSkeleton {
    width: 62px;
  }
}
